import * as React from "react";
const SvgFiRrPhoneSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-phone-slash_svg__a)">
      <path
        fill="#062147"
        d="M23.7.307a1 1 0 0 0-1.413 0L10.093 12.494A14.2 14.2 0 0 1 7.98 9.085l1.158-1.454a3.1 3.1 0 0 0 .007-4.277S7.294.95 7.264.92A3.08 3.08 0 0 0 2.94.873l-1.15 1c-4.015 4.448-.637 10.714 3.55 15.371L.3 22.28a1 1 0 0 0 1.413 1.413L23.7 1.72a1 1 0 0 0 0-1.413M2.007 6.245a4.12 4.12 0 0 1 1.146-2.909l1.149-1a1.1 1.1 0 0 1 1.509-.039s1.84 2.39 1.87 2.42a1.094 1.094 0 0 1 0 1.546C7.657 6.29 6.049 8.3 6.049 8.3a1 1 0 0 0-.148 1 16.4 16.4 0 0 0 2.766 4.618l-1.914 1.915c-2.943-3.159-4.745-6.746-4.745-9.588m21.078 10.488a3.1 3.1 0 0 1 0 4.373l-.91 1.048C18.3 25.681 13.6 23.618 9.2 20.645a1 1 0 0 1 1.2-1.6c3.509 2.315 7.332 4.342 10.32 1.75l.91-1.05a1.117 1.117 0 0 0 .086-1.558s-2.392-1.84-2.422-1.87a1.1 1.1 0 0 0-1.548 0c-.027.027-2.043 1.633-2.043 1.633a1 1 0 0 1-.964.157 15.4 15.4 0 0 1-1.912-.88 1 1 0 0 1 .932-1.764c.37.2.756.391 1.156.561l1.462-1.163a3.1 3.1 0 0 1 4.278-.006s2.399 1.845 2.43 1.878"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-phone-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhoneSlash;
